<script setup>
import { useStore } from "vuex";
import { computed, onMounted, ref } from "vue";
import AppSidebar from "@/components/layouts/AppSidebar.vue";
import AppTopbar from "@/components/layouts/AppTopbar.vue";
import { useLoading } from "vue-loading-overlay";

const $loading = useLoading({});
const store = useStore()
const currentUserData = computed(() => store.getters['user/currentUserData'])

const getCurrentUser = (val) => store.dispatch('user/getCurrentUser', val)

// AppTopbar (and its #topbar-actions Teleport target) is a sibling of
// router-view, so it must finish mounting first — pages Teleport into it
// on their own mount, and Teleport resolves its target with a
// document.querySelector at that moment. Vue mounts children before
// inserting their parent element into the document, so on the very patch
// that creates the .admin branch the topbar markup is not in the document
// yet. The flag below is driven by AppTopbar's own mount/unmount vnode
// hooks (post-render, i.e. after insertion), which keeps the gate correct
// on every mount of the branch — first paint, login → dashboard, and
// logout → login → back in. Don't turn it into a one-shot latch.
const topbarReady = ref(false)

onMounted(() => {
  const loader = $loading.show({})
  getCurrentUser()
      .finally(loader.hide)
})
</script>

<template>
  <div class="main-wrapper">
    <div class="login-page" v-if="$route.path === '/login'">
      <router-view></router-view>
    </div>
    <div class="admin" v-else>
      <AppSidebar
          :user-role="currentUserData.role"
          :user-name="currentUserData.first_name"
          :user-email="currentUserData.email"/>
      <div class="main">
        <AppTopbar
            @vue:mounted="topbarReady = true"
            @vue:unmounted="topbarReady = false"/>
        <div class="content">
          <router-view v-if="topbarReady"></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
